"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SSO_IDENTITY_LOGIN_PATH = exports.SSO_IDENTITY_AD_LOGIN_PATH = void 0;
const SSO_IDENTITY_LOGIN_PATH = exports.SSO_IDENTITY_LOGIN_PATH = '/ssoidentity/Login';
const SSO_IDENTITY_AD_LOGIN_PATH = exports.SSO_IDENTITY_AD_LOGIN_PATH = `${SSO_IDENTITY_LOGIN_PATH}?ssoLoginType=ActiveDirectory`;